import React, {ReactNode, useRef, useState} from 'react'
import TextureIcon from '@mui/icons-material/Texture'
import {SetStatePropsType} from '@baseTypes/base'
import Box from '@mui/material/Box'
import {SxType} from '@baseTypes/sx/sxTypes'

interface IProps {
	children: ReactNode;
	width: number,
	setWidth: SetStatePropsType<number>,
	height: number,
	setHeight: SetStatePropsType<number>,
	className?: string
	buttonPositionsSx?: SxType
	buttonPositionsIconSx?: SxType
}

const ResizableBox = ({
						  children,
						  width,
						  height,
						  setWidth,
						  setHeight,
						  className,
						  buttonPositionsSx,
						  buttonPositionsIconSx,
					  }: IProps) => {
	
	const [isResizing, setIsResizing] = useState<boolean>(false)
	const boxRef = useRef<HTMLDivElement>(null)
	
	const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		e.preventDefault()
		setIsResizing(true)
		window.addEventListener('mousemove', handleMouseMove)
		window.addEventListener('mouseup', handleMouseUp)
	}
	
	const handleMouseMove = (e: MouseEvent) => {
		if (boxRef.current) {
			const rect = boxRef.current.getBoundingClientRect()
			const newWidth = e.clientX - rect.left
			const newHeight = e.clientY - rect.top
			setWidth(newWidth)
			setHeight(newHeight)
		}
	}
	const handleMouseUp = () => {
		window.removeEventListener('mousemove', handleMouseMove)
		window.removeEventListener('mouseup', handleMouseUp)
	}
	
	return (
		<div
			ref={boxRef}
			style={{
				width: `${width}px`,
				height: `${height}px`,
			}}
			className={className}
		>
			{children}
			
			<Box
				sx={buttonPositionsSx || {
					position: 'absolute',
					right: '20px',
					bottom: '10px',
					width: '20px',
					height: '20px',
					zIndex: 555,
					cursor: 'se-resize',
					backgroundColor: '#fff',
					borderRadius: '5px'
				}}
				onMouseDown={handleMouseDown}
			>
				<TextureIcon
					sx={buttonPositionsIconSx || {
						width: '20px',
						height: '20px',
						color: '#00000'
					}}
				/>
			</Box>
		</div>
	)
}

export default ResizableBox